module.exports = __webpack_public_path__ + "img/arrow-right-to-line.fcae7f48.svg";